import endpointConfig from "../configs/endpoint.config";
import httpConfig from "../configs/http.config";
import { ActivateActionBodyProps, ActivateActionResponseProps, ActivateTypeBodyProps, ActivateTypeResponseProps, CreateTypeBodyProps, CreateTypeResponseProps, EditTypeBodyProps, EditTypeLimitedToBodyProps, EditTypeLimitedToResponseProps, EditTypeResponseProps, ResultNewApiPayloadProps, ResultNewApiProps, ResultUploadDocumentApiPayloadProps, ResultUploadDocumentApiProps, ResultUploadImageApiPayloadProps, ResultUploadImageApiProps, ResultUploadSignatureApiPayloadProps, ResultUploadSignatureApiProps, TypeBodyProps, TypeLimitedToBodyProps, TypeLimitedToResponseProps, TypeResponseProps, TypesBodyProps, TypesResponseProps } from "../types/task.type";

const taskService = {
  types: async function(body: TypesBodyProps) {
    const response = await httpConfig().post<TypesResponseProps>(endpointConfig.task.types, body)
    if (response.data.code !== '200') throw response.data
    return response.data
  },
  type: async function(body: TypeBodyProps) {
    const response = await httpConfig().post<TypeResponseProps>(endpointConfig.task.type, body)
    if (response.data.code !== '200') throw response.data
    return response.data
  },
  typeLimitedTo: async function(body: TypeLimitedToBodyProps) {
    const response = await httpConfig().post<TypeLimitedToResponseProps>(endpointConfig.task.typeLimitedTo, body)
    if (response.data.code !== '200') throw response.data
    return response.data
  },
  editTypeLimitedTo: async function(body: EditTypeLimitedToBodyProps) {
    const response = await httpConfig().post<EditTypeLimitedToResponseProps>(endpointConfig.task.editTypeLimitedTo, {
      ...body,
      members: JSON.stringify(body?.members)
    })
    if (response.data.code !== '200') throw response.data
    return response.data
  },
  createType: async function(body: CreateTypeBodyProps) {
    const response = await httpConfig().post<CreateTypeResponseProps>(endpointConfig.task.createType, body)
    if (response.data.code !== '200') throw response.data
    return response.data
  },
  editType: async function(body: EditTypeBodyProps) {
    const response = await httpConfig().post<EditTypeResponseProps>(endpointConfig.task.editType, body)
    if (response.data.code !== '200') throw response.data
    return response.data
  },
  activateType: async function(body: ActivateTypeBodyProps) {
    const response = await httpConfig().post<ActivateTypeResponseProps>(endpointConfig.task.activateType, body)
    if (response.data.code !== '200') throw response.data
    return response.data
  },
  inactivateType: async function(body: ActivateTypeBodyProps) {
    const response = await httpConfig().post<ActivateTypeResponseProps>(endpointConfig.task.inactivateType, body)
    if (response.data.code !== '200') throw response.data
    return response.data
  },
  activateAction: async function(body: ActivateActionBodyProps) {
    const response = await httpConfig().post<ActivateActionResponseProps>(endpointConfig.task.activateAction, body)
    if (response.data.code !== '200') throw response.data
    return response.data
  },
  inactivateAction: async function(body: ActivateActionBodyProps) {
    const response = await httpConfig().post<ActivateActionResponseProps>(endpointConfig.task.inactivateAction, body)
    if (response.data.code !== '200') throw response.data
    return response.data
  },
  resultNew: async function(body: ResultNewApiPayloadProps) {
    const response = await httpConfig().post<ResultNewApiProps>(endpointConfig.task.resultNew, {
      ...body,
      task_result_value: JSON.stringify(body?.task_result_value)
    })
    if (response.data.code !== '200') throw response.data
    return response.data
  },
  resultDocument: async function(payload: ResultUploadDocumentApiPayloadProps) {
    const formData = new FormData()
    formData.set('profile_id', localStorage.getItem('team_id') ?? '')
    formData.set('action_template_id', payload?.action_template_id?.toString())
    formData.set('address', payload?.address?.toString())
    formData.set('datetime', payload?.datetime?.toString())
    formData.set('document', payload?.document)
    formData.set('latitude', payload?.latitude?.toString())
    formData.set('longitude', payload?.longitude?.toString())
    formData.set('task_assignment_id', payload?.task_assignment_id?.toString())
    formData.set('trx_id', payload?.trx_id?.toString())
    formData.set('task_result_id', payload?.task_result_id?.toString())
    const response = await httpConfig().post<ResultUploadDocumentApiProps>(endpointConfig.task.resultDocument, formData)
    if (response.data.code !== '200') throw response.data
    return response.data
  },
  resultImage: async function(payload: ResultUploadImageApiPayloadProps) {
    const formData = new FormData()
    formData.set('profile_id', localStorage.getItem('team_id') ?? '')
    formData.set('action_template_id', payload?.action_template_id?.toString())
    formData.set('address', payload?.address?.toString())
    formData.set('datetime', payload?.datetime?.toString())
    formData.set('image', payload?.image)
    formData.set('latitude', payload?.latitude?.toString())
    formData.set('longitude', payload?.longitude?.toString())
    formData.set('task_assignment_id', payload?.task_assignment_id?.toString())
    formData.set('trx_id', payload?.trx_id?.toString())
    formData.set('task_result_id', payload?.task_result_id?.toString())
    formData.set('from_gallery', '0')
    const response = await httpConfig().post<ResultUploadImageApiProps>(endpointConfig.task.resultImage, formData)
    if (response.data.code !== '200') throw response.data
    return response.data
  },
  resultSignature: async function(payload: ResultUploadSignatureApiPayloadProps) {
    const formData = new FormData()
    formData.set('profile_id', localStorage.getItem('team_id') ?? '')
    formData.set('action_template_id', payload?.action_template_id?.toString())
    formData.set('address', payload?.address?.toString())
    formData.set('datetime', payload?.datetime?.toString())
    formData.set('signature', payload?.signature)
    formData.set('latitude', payload?.latitude?.toString())
    formData.set('longitude', payload?.longitude?.toString())
    formData.set('task_assignment_id', payload?.task_assignment_id?.toString())
    formData.set('trx_id', payload?.trx_id?.toString())
    formData.set('task_result_id', payload?.task_result_id?.toString())
    const response = await httpConfig().post<ResultUploadSignatureApiProps>(endpointConfig.task.resultSignature, formData)
    if (response.data.code !== '200') throw response.data
    return response.data
  },
}

export default taskService